import React  from 'react';
import { Typography } from "antd";

const { Paragraph } = Typography; // Переименовываем Text во избежание конфликта

const PlainTextContentView = ({content}) => (
    <Paragraph
        style={{width: '100%', textAlign: 'left', whiteSpace: 'pre-wrap'}}
        ellipsis={{rows: 12, expandable: true, symbol: ' Больше...'}}
    >
        {content}
    </Paragraph>
)

export default PlainTextContentView;
